import React, { useState, useEffect } from 'react';

const ShopInsightCreditPackages: React.FC<{ message: string }> = ({ message }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    // Navigate to the profile page
    window.location.href = '/profile';
  };

  if (!isOpen) return null;

  return (
    <>
      <style>{`
        .insights-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          backdrop-filter: blur(5px);
        }

        .insights-modal {
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          padding: 2rem;
          max-width: 500px;
          width: 90%;
          position: relative;
          animation: modalFadeIn 0.3s ease-out;
        }

        @keyframes modalFadeIn {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }

        .close-button {
          position: absolute;
          top: 10px;
          right: 10px;
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: #666;
        }

        .insights-content {
          text-align: center;
        }

        h2 {
          color: #333;
          margin-bottom: 1rem;
        }

        .insights-message {
          font-size: 1.1rem;
          color: #555;
          margin-bottom: 1rem;
        }

        .insights-description {
          color: #666;
          margin-bottom: 1.5rem;
        }

        .insights-benefits {
          display: flex;
          justify-content: space-around;
          margin-bottom: 1.5rem;
        }

        .benefit-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0 1rem;
        }

        .benefit-icon {
          font-size: 2rem;
          margin-bottom: 0.5rem;
        }

        .benefit-title {
          font-weight: bold;
          margin-bottom: 0.5rem;
        }

        .benefit-description {
          font-size: 0.9rem;
          color: #666;
          text-align: center;
        }

        .buy-button {
          display: inline-block;
          background-color: #9c54fc;
          color: white;
          text-decoration: none;
          padding: 0.8rem 1.5rem;
          border-radius: 25px;
          font-weight: bold;
          transition: background-color 0.3s ease;
        }

        .buy-button:hover {
          background-color: #8a3fe0;
          color: white;
          text-decoration: none;
        }

        .dark-mode .insights-modal {
          background-color: #222328;
          color: #ffffff;
          border: 1px solid #322f2f;
          box-shadow: 0 10px 24px rgba(0, 0, 0, 0.24);
        }

        .dark-mode .close-button,
        .dark-mode .insights-description,
        .dark-mode .benefit-description {
          color: #9c9fa6;
        }

        .dark-mode h2,
        .dark-mode .insights-message,
        .dark-mode .benefit-title {
          color: #ffffff;
        }

        .dark-mode .buy-button {
          background-color: #b66dff;
        }

        .dark-mode .buy-button:hover {
          background-color: #9a55ff;
        }
      `}</style>
      <div className="insights-modal-overlay">
        <div className="insights-modal">
          <button className="close-button" onClick={handleClose}>&times;</button>
          <div className="insights-content">
            <h2>Unlock More AI Insights</h2>
            <p className="insights-message">{message}</p>
            <p className="insights-description">
              Get 100 additional Autonomous AI-generated insights for $14.99
            </p>
            <div className="insights-benefits">
              <div className="benefit-item">
                <span className="benefit-icon">🎯</span>
                <span className="benefit-title">AI-Powered Analysis</span>
                <span className="benefit-description">Deep insights from advanced AI agents</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">⏳</span>
                <span className="benefit-title">Never Expire</span>
                <span className="benefit-description">Credits remain valid until used</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">⚡</span>
                <span className="benefit-title">Instant Access</span>
                <span className="benefit-description">Extra insights ready when you need them</span>
              </div>
            </div>
            <a href="/checkout/insight_credit_packages" className="buy-button">Get 100 Insights ($14.99)</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShopInsightCreditPackages;
